// Generated file : do not modify
export enum ContratModeCalculs
{
  NONE = 0,
  TAUX,
  BRUT,
  NET,
  TOTAL
};

export enum ContratStatuts
{
  NONE = 0,
  CREATED,
  COMPUTED,
  NOT_MANAGED,
  GENERATED,
  WAITING_OLD,
  SUBMITTED,
  COMMENTED,
  MODIFIED,
  APPROUVED,
  SIGNED,
  CHECKED,
  CANCELLED,
  SALARIE_SIGNED,
  CI98
};

export enum ContratStatutDashboards
{
  NONE = 0,
  PREPARATION,
  A_SIGNER_SALARIE,
  A_SIGNER_EMPLOYEUR,
  A_REGLER,
  PAYER,
  ATTENTE_PRESTATION,
  TERMINER,
  SUPPRIME,
  PRE_PAYEE,
  REGLE_A_VALIDER
};

export enum ContratDpaeStatuts
{
  NONE = 0,
  INITIAL,
  PROPOSEE,
  HORS_DELAI,
  NON_GERE,
  SALARIE_INCONNU,
  INCOMPLETE_EMPLOYEUR,
  INCOMPLETE_SALARIE,
  ATTENTE_ENVOI,
  ENVOYEE,
  RETOUR_OK,
  RETOUR_INVALIDE,
  OBLIGATOIRE
};

export enum ContratAemStatuts
{
  NONE = 0,
  PDF,
  EDI,
  ERROR,
  OK
};

export enum ContratValidStatuts
{
  NONE = 0,
  COMPLETE_POUR_SALARIE,
  VALID_EMPLOYEUR,
  FISCALITE_SALARIE,
  RIB_SALARIE,
  APPROVE_SALARIE
};

import { BaseSalarie } from '@/extend/classes/Rubrique';
import { RubriquePaie } from '@/extend/classes/Rubrique';
import { VariablePaie } from '@/extend/classes/Rubrique';
import { SynthesePaie } from '@/extend/classes/Paie';
import { MetaValue } from '@/extend/classes/MetaAttrib';
import { GraphAnswer } from '@/extend/classes/GraphData';
import { GraphMinimum } from '@/extend/classes/GraphData';
import { ListFilter } from '@/extend/classes/ListData';
import { DpaeMasseQuery } from '@/extend/classes/DpaeMasseResult';
import { ControleSignatureMasseQuery } from '@/extend/classes/ResultatContratMasse';
import { AppliquerObjetCommunQuery } from '@/extend/classes/ResultatContratMasse';
import { AppliquerModeleContratQuery } from '@/extend/classes/ResultatContratMasse';
import { EnvoiSignatureMasseQuery } from '@/extend/classes/ResultatContratMasse';
import ListData from '@/extend/classes/ListData';
import DpaeMasseResult from '@/extend/classes/DpaeMasseResult';
import { ControleSignatureMasseResult } from '@/extend/classes/ResultatContratMasse';
import { AppliquerObjetCommunResult } from '@/extend/classes/ResultatContratMasse';
import { AppliquerModeleContratResult } from '@/extend/classes/ResultatContratMasse';
import { EnvoiSignatureMasseResult } from '@/extend/classes/ResultatContratMasse';
import { NotifDefTypes } from '@/generated/classes/NotifDef';
import { storeSession } from '@/generated/stores';
import { type AxiosResponse } from 'axios';
import {getRequestConfig} from "@/framework/base/helpers/HttpHelper.ts";

// Contrats de travail
export default class Contrat  {
  // Identifiant unique
  public id: number;
  // Code contrat 98
  public codeContrat: number;
  // Code chèque 98
  public codeCheque: number;
  // Référence
  public nom: string;
  // Id projet
  public projetId: number;
  // Signataire
  public signataireId: number;
  // to hide section while not saved
  public signatorySaved: boolean;
  // Salarié
  public salarieId: number;
  // Emploi
  public emploiId: number;
  // Convention
  public conventionAppliqueeId: number;
  // Artiste
  public artiste: boolean;
  // Emploi
  public emploiNom: string;
  // Convention
  public conventionNom: string;
  // Etablissement
  public etablissementId: number;
  // Lieu
  public lieuId: number;
  // Gestionnaire
  public gestionnaireId: number;
  // Bases appliqué au salarié
  public basesSalarie: BaseSalarie[];
  // Rubriques de paie
  public rubriques: RubriquePaie[];
  // Variables de paie
  public variables: VariablePaie[];
  // Base salarié
  public editBaseSalarie: number;
  // Creneaux valides
  public creneauxValid: boolean;
  // Les paies sont valides
  public valide: boolean;
  // Synthèse de la paie
  public synthesePaies: SynthesePaie[];
  // Date de début
  public dateDebut: Date;
  // Date de fin
  public dateFin: Date | null;
  // Mode de calcul
  public modeCalcul: ContratModeCalculs;
  // template des articles du contrat
  public contratTemplateId: number;
  // Statut
  public statut: ContratStatuts;
  // Statut Dashboard
  public statutDashboard: ContratStatutDashboards;
  // Date de soumission
  public submittedAt: Date | null;
  // Date d'approbation
  public approvedAt: Date | null;
  // Date de dernier commentaire
  public commentedAt: Date | null;
  // Auteur du dernier commentaire
  public commentedBy: number;
  // Date de signature
  public signedAt: Date | null;
  // Date d'annulation
  public cancelledAt: Date | null;
  // Licence ignorée
  public ignoreLicence: boolean | null;
  // Les données à renseigner par l'employeur sont toutes présentes
  public userCompleted: boolean;
  // Les données à renseigner par le salarié sont toutes présentes
  public salarieCompleted: boolean;
  // Statut de la DPAE
  public dpaeStatut: ContratDpaeStatuts;
  // Date du statut de la DPAE
  public dpaeDate: Date | null;
  // Info si Statut du retour Urssaf KO
  public dpaeError: string;
  // Référence accusé réception de la DPAE
  public dpaeReference: string;
  // ID DPAE
  public dpaeId: string;
  // Je dispose du formulaire A1 et demande à être exonéré de cotisations
  public exoEtranger: boolean | null;
  // Le contrat doit être soumis par l'employeur
  public toSubmit: boolean;
  // Le contrat doit être accepté par la salarié
  public toApprove: boolean;
  // Le document associé possède une version avec des révisions pour l'employeur
  public hasUserUpdate: boolean;
  // Le document associé possède une version avec des révisions pour le salarié
  public hasSalarieUpdate: boolean;
  // Numéro AEM
  public aemNumero: number;
  // Statut AEM
  public aemStatut: ContratAemStatuts;
  // Avis de dépot AEM
  public aemDepot: number;
  // date d'envoi AEM
  public aemDate: Date | null;
  public validStatut: ContratValidStatuts;
  // 
  public chatId: number;
  // Méta-attributs
  public metaValues: MetaValue[];
  // Graph answers
  public graphAnswers: GraphAnswer[];
  // Graph minimum
  public graphMinimum: GraphMinimum;
  // GUID de création du store
  public createId: string;
  // Commande non exécutée
  public failed: boolean;
  // Donnée pouvant être  modifiée
  public canUpdate: boolean;
  // Donnée pouvant être supprimée
  public canDelete: boolean;
  // Display des objets
  public display: string;
  // Client
  public clientId: number;
  // Type de notification
  public notifDefType: NotifDefTypes;

  constructor() {
    this.id = 0;
    this.codeContrat = 0;
    this.codeCheque = 0;
    this.nom = '';
    this.projetId = 0;
    this.signataireId = 0;
    this.signatorySaved = false;
    this.salarieId = 0;
    this.emploiId = 0;
    this.conventionAppliqueeId = 0;
    this.artiste = false;
    this.emploiNom = '';
    this.conventionNom = '';
    this.etablissementId = 0;
    this.lieuId = 0;
    this.gestionnaireId = 0;
    this.basesSalarie = [];
    this.rubriques = [];
    this.variables = [];
    this.editBaseSalarie = 0;
    this.creneauxValid = false;
    this.valide = false;
    this.synthesePaies = [];
    this.dateDebut = new Date(1901,1,1,0,0,0,0);
    this.dateFin = null;
    this.modeCalcul = ContratModeCalculs.NONE;
    this.contratTemplateId = 0;
    this.statut = ContratStatuts.NONE;
    this.statutDashboard = ContratStatutDashboards.NONE;
    this.submittedAt = null;
    this.approvedAt = null;
    this.commentedAt = null;
    this.commentedBy = 0;
    this.signedAt = null;
    this.cancelledAt = null;
    this.ignoreLicence = null;
    this.userCompleted = false;
    this.salarieCompleted = false;
    this.dpaeStatut = ContratDpaeStatuts.NONE;
    this.dpaeDate = null;
    this.dpaeError = '';
    this.dpaeReference = '';
    this.dpaeId = '';
    this.exoEtranger = null;
    this.toSubmit = false;
    this.toApprove = false;
    this.hasUserUpdate = false;
    this.hasSalarieUpdate = false;
    this.aemNumero = 0;
    this.aemStatut = ContratAemStatuts.NONE;
    this.aemDepot = 0;
    this.aemDate = null;
    this.validStatut = ContratValidStatuts.NONE;
    this.chatId = 0;
    this.metaValues = [];
    this.graphAnswers = [];
    this.graphMinimum = new GraphMinimum();
    this.createId = '';
    this.failed = false;
    this.canUpdate = true;
    this.canDelete = true;
    this.display = '';
    this.clientId = 0;
    this.notifDefType = NotifDefTypes.NONE;
  }

  public static fromJson (obj: Contrat): Contrat {
    const newContrat: Contrat = new Contrat();
    newContrat.id = obj.id;
    newContrat.codeContrat = obj.codeContrat;
    newContrat.codeCheque = obj.codeCheque;
    newContrat.nom = obj.nom;
    newContrat.projetId = obj.projetId;
    newContrat.signataireId = obj.signataireId;
    newContrat.signatorySaved = obj.signatorySaved;
    newContrat.salarieId = obj.salarieId;
    newContrat.emploiId = obj.emploiId;
    newContrat.conventionAppliqueeId = obj.conventionAppliqueeId;
    newContrat.artiste = obj.artiste;
    newContrat.emploiNom = obj.emploiNom;
    newContrat.conventionNom = obj.conventionNom;
    newContrat.etablissementId = obj.etablissementId;
    newContrat.lieuId = obj.lieuId;
    newContrat.gestionnaireId = obj.gestionnaireId;
    newContrat.basesSalarie = JSON.parse(JSON.stringify(obj.basesSalarie));
    newContrat.rubriques = JSON.parse(JSON.stringify(obj.rubriques));
    newContrat.variables = JSON.parse(JSON.stringify(obj.variables));
    newContrat.editBaseSalarie = obj.editBaseSalarie;
    newContrat.creneauxValid = obj.creneauxValid;
    newContrat.valide = obj.valide;
    newContrat.synthesePaies = JSON.parse(JSON.stringify(obj.synthesePaies));
    newContrat.dateDebut = new Date(obj.dateDebut);
    newContrat.dateFin = obj.dateFin ? new Date(obj.dateFin) : null;
    newContrat.modeCalcul = obj.modeCalcul;
    newContrat.contratTemplateId = obj.contratTemplateId;
    newContrat.statut = obj.statut;
    newContrat.statutDashboard = obj.statutDashboard;
    newContrat.submittedAt = obj.submittedAt ? new Date(obj.submittedAt) : null;
    newContrat.approvedAt = obj.approvedAt ? new Date(obj.approvedAt) : null;
    newContrat.commentedAt = obj.commentedAt ? new Date(obj.commentedAt) : null;
    newContrat.commentedBy = obj.commentedBy;
    newContrat.signedAt = obj.signedAt ? new Date(obj.signedAt) : null;
    newContrat.cancelledAt = obj.cancelledAt ? new Date(obj.cancelledAt) : null;
    newContrat.ignoreLicence = obj.ignoreLicence;
    newContrat.userCompleted = obj.userCompleted;
    newContrat.salarieCompleted = obj.salarieCompleted;
    newContrat.dpaeStatut = obj.dpaeStatut;
    newContrat.dpaeDate = obj.dpaeDate ? new Date(obj.dpaeDate) : null;
    newContrat.dpaeError = obj.dpaeError;
    newContrat.dpaeReference = obj.dpaeReference;
    newContrat.dpaeId = obj.dpaeId;
    newContrat.exoEtranger = obj.exoEtranger;
    newContrat.toSubmit = obj.toSubmit;
    newContrat.toApprove = obj.toApprove;
    newContrat.hasUserUpdate = obj.hasUserUpdate;
    newContrat.hasSalarieUpdate = obj.hasSalarieUpdate;
    newContrat.aemNumero = obj.aemNumero;
    newContrat.aemStatut = obj.aemStatut;
    newContrat.aemDepot = obj.aemDepot;
    newContrat.aemDate = obj.aemDate ? new Date(obj.aemDate) : null;
    newContrat.validStatut = obj.validStatut;
    newContrat.chatId = obj.chatId;
    newContrat.metaValues = JSON.parse(JSON.stringify(obj.metaValues));
    newContrat.graphAnswers = JSON.parse(JSON.stringify(obj.graphAnswers));
    newContrat.graphMinimum = JSON.parse(JSON.stringify(obj.graphMinimum));
    newContrat.createId = obj.createId;
    newContrat.failed = obj.failed;
    newContrat.canUpdate = obj.canUpdate;
    newContrat.canDelete = obj.canDelete;
    newContrat.display = obj.display;
    newContrat.clientId = obj.clientId;
    newContrat.notifDefType = obj.notifDefType;
    return newContrat;
  }

  public toJsonContrat (): string {
    const json = {
      codeContrat: this.codeContrat,
      codeCheque: this.codeCheque,
      nom: this.nom,
      projetId: this.projetId,
      signataireId: this.signataireId,
      signatorySaved: this.signatorySaved,
      salarieId: this.salarieId,
      emploiId: this.emploiId,
      conventionAppliqueeId: this.conventionAppliqueeId,
      artiste: this.artiste,
      emploiNom: this.emploiNom,
      conventionNom: this.conventionNom,
      etablissementId: this.etablissementId,
      lieuId: this.lieuId,
      gestionnaireId: this.gestionnaireId,
      basesSalarie: this.basesSalarie,
      rubriques: this.rubriques,
      variables: this.variables,
      editBaseSalarie: this.editBaseSalarie,
      creneauxValid: this.creneauxValid,
      valide: this.valide,
      synthesePaies: this.synthesePaies,
      dateDebut: this.dateDebut ? new Date (this.dateDebut).toString() : this.dateDebut,
      dateFin: this.dateFin ? new Date (this.dateFin).toString() : this.dateFin,
      modeCalcul: this.modeCalcul,
      contratTemplateId: this.contratTemplateId,
      statut: this.statut,
      statutDashboard: this.statutDashboard,
      submittedAt: this.submittedAt ? new Date (this.submittedAt).toString() : this.submittedAt,
      approvedAt: this.approvedAt ? new Date (this.approvedAt).toString() : this.approvedAt,
      commentedAt: this.commentedAt ? new Date (this.commentedAt).toString() : this.commentedAt,
      commentedBy: this.commentedBy,
      signedAt: this.signedAt ? new Date (this.signedAt).toString() : this.signedAt,
      cancelledAt: this.cancelledAt ? new Date (this.cancelledAt).toString() : this.cancelledAt,
      ignoreLicence: this.ignoreLicence,
      userCompleted: this.userCompleted,
      salarieCompleted: this.salarieCompleted,
      dpaeStatut: this.dpaeStatut,
      dpaeDate: this.dpaeDate ? new Date (this.dpaeDate).toString() : this.dpaeDate,
      dpaeError: this.dpaeError,
      dpaeReference: this.dpaeReference,
      dpaeId: this.dpaeId,
      exoEtranger: this.exoEtranger,
      toSubmit: this.toSubmit,
      toApprove: this.toApprove,
      hasUserUpdate: this.hasUserUpdate,
      hasSalarieUpdate: this.hasSalarieUpdate,
      aemNumero: this.aemNumero,
      aemStatut: this.aemStatut,
      aemDepot: this.aemDepot,
      aemDate: this.aemDate ? new Date (this.aemDate).toString() : this.aemDate,
      validStatut: this.validStatut,
      chatId: this.chatId,
      metaValues: this.metaValues,
      graphAnswers: this.graphAnswers,
      graphMinimum: this.graphMinimum,
      canUpdate: this.canUpdate,
      canDelete: this.canDelete,
      notifDefType: this.notifDefType,
    }
    return JSON.stringify(json);
  }

  public fromContrat (obj: Contrat): void {
    this.id = obj.id;
    this.codeContrat = obj.codeContrat;
    this.codeCheque = obj.codeCheque;
    this.nom = obj.nom;
    this.projetId = obj.projetId;
    this.signataireId = obj.signataireId;
    this.signatorySaved = obj.signatorySaved;
    this.salarieId = obj.salarieId;
    this.emploiId = obj.emploiId;
    this.conventionAppliqueeId = obj.conventionAppliqueeId;
    this.artiste = obj.artiste;
    this.emploiNom = obj.emploiNom;
    this.conventionNom = obj.conventionNom;
    this.etablissementId = obj.etablissementId;
    this.lieuId = obj.lieuId;
    this.gestionnaireId = obj.gestionnaireId;
    this.basesSalarie = obj.basesSalarie;
    this.rubriques = obj.rubriques;
    this.variables = obj.variables;
    this.editBaseSalarie = obj.editBaseSalarie;
    this.creneauxValid = obj.creneauxValid;
    this.valide = obj.valide;
    this.synthesePaies = obj.synthesePaies;
    this.dateDebut = new Date(obj.dateDebut);
    this.dateFin = obj.dateFin;
    this.modeCalcul = obj.modeCalcul;
    this.contratTemplateId = obj.contratTemplateId;
    this.statut = obj.statut;
    this.statutDashboard = obj.statutDashboard;
    this.submittedAt = obj.submittedAt;
    this.approvedAt = obj.approvedAt;
    this.commentedAt = obj.commentedAt;
    this.commentedBy = obj.commentedBy;
    this.signedAt = obj.signedAt;
    this.cancelledAt = obj.cancelledAt;
    this.ignoreLicence = obj.ignoreLicence;
    this.userCompleted = obj.userCompleted;
    this.salarieCompleted = obj.salarieCompleted;
    this.dpaeStatut = obj.dpaeStatut;
    this.dpaeDate = obj.dpaeDate;
    this.dpaeError = obj.dpaeError;
    this.dpaeReference = obj.dpaeReference;
    this.dpaeId = obj.dpaeId;
    this.exoEtranger = obj.exoEtranger;
    this.toSubmit = obj.toSubmit;
    this.toApprove = obj.toApprove;
    this.hasUserUpdate = obj.hasUserUpdate;
    this.hasSalarieUpdate = obj.hasSalarieUpdate;
    this.aemNumero = obj.aemNumero;
    this.aemStatut = obj.aemStatut;
    this.aemDepot = obj.aemDepot;
    this.aemDate = obj.aemDate;
    this.validStatut = obj.validStatut;
    this.chatId = obj.chatId;
    this.metaValues = obj.metaValues;
    this.graphAnswers = obj.graphAnswers;
    this.graphMinimum = obj.graphMinimum;
    this.createId = obj.createId;
    this.failed = obj.failed;
    this.canUpdate = obj.canUpdate;
    this.canDelete = obj.canDelete;
    this.display = obj.display;
    this.clientId = obj.clientId;
    this.notifDefType = obj.notifDefType;
  }

  public compareContrat (value: Contrat): boolean {
    return (this.toJsonContrat() == value.toJsonContrat());
  }

  public cloneContrat (): Contrat {
    return Contrat.fromJson(this);
  }

  public createForStoreContrat (): Promise<Contrat> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/contrats/', this, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              this.fromContrat(res.data);
              resolve(this);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public updateForStoreContrat (): Promise<Contrat> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.put('api/contrats/', this, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              this.fromContrat(res.data);
              resolve(this);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public deleteForStoreContrat (): Promise<void> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.delete('api/contrats/' + this.id, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve();
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static list (filter: ListFilter): Promise<ListData> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/contrats/list', filter, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static calcul (contrat: Contrat): Promise<Contrat> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/contrats/calcul', contrat, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(Contrat.fromJson(res.data));
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static submit (contrat: Contrat): Promise<Contrat> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/contrats/submit', contrat, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(Contrat.fromJson(res.data));
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static approve (contrat: Contrat): Promise<Contrat> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/contrats/approve', contrat, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(Contrat.fromJson(res.data));
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static modify (contrat: Contrat): Promise<boolean> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/contrats/modify', contrat, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static display (contrat: Contrat): Promise<Contrat> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/contrats/display', contrat, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(Contrat.fromJson(res.data));
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static sign (contrat: Contrat): Promise<Contrat> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/contrats/sign', contrat, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(Contrat.fromJson(res.data));
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static duplicate (contrat: Contrat): Promise<Contrat> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/contrats/duplicate', contrat, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(Contrat.fromJson(res.data));
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static downloadA1 (contrat: Contrat): Promise<boolean> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/contrats/downloadA1', contrat, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static displayA1 (contrat: Contrat): Promise<boolean> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/contrats/displayA1', contrat, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static dpaeMasse (query: DpaeMasseQuery): Promise<DpaeMasseResult> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/contrats/dpaeMasse', query, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static controleSignatureMasse (query: ControleSignatureMasseQuery): Promise<ControleSignatureMasseResult> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/contrats/controleSignatureMasse', query, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static appliquerObjetCommun (query: AppliquerObjetCommunQuery): Promise<AppliquerObjetCommunResult> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/contrats/appliquerObjetCommun', query, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static appliquerModeleContrat (query: AppliquerModeleContratQuery): Promise<AppliquerModeleContratResult> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/contrats/appliquerModeleContrat', query, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static envoyerSignatureMasse (query: EnvoiSignatureMasseQuery): Promise<EnvoiSignatureMasseResult> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/contrats/envoyerSignatureMasse', query, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static getForStore (id: number): Promise<ListData> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/Contrats/' + id.toString(), getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              const listData = res.data as ListData;
              listData.reccords[0] = Contrat.fromJson(listData.reccords[0] as Contrat);
              resolve(listData);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static get (id: number): Promise<Contrat> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/Contrats/' + id.toString(), getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              const listData = res.data as ListData;
              const data = Contrat.fromJson(listData.reccords[0] as Contrat);
              resolve(data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static getDate(contrats: Contrat[]) {
    contrats.forEach((item) => {
      item.dateDebut = item.dateDebut ? new Date(item.dateDebut) : item.dateDebut;
      item.dateFin = item.dateFin ? new Date(item.dateFin) : item.dateFin;
      item.submittedAt = item.submittedAt ? new Date(item.submittedAt) : item.submittedAt;
      item.approvedAt = item.approvedAt ? new Date(item.approvedAt) : item.approvedAt;
      item.commentedAt = item.commentedAt ? new Date(item.commentedAt) : item.commentedAt;
      item.signedAt = item.signedAt ? new Date(item.signedAt) : item.signedAt;
      item.cancelledAt = item.cancelledAt ? new Date(item.cancelledAt) : item.cancelledAt;
      item.dpaeDate = item.dpaeDate ? new Date(item.dpaeDate) : item.dpaeDate;
      item.aemDate = item.aemDate ? new Date(item.aemDate) : item.aemDate;
    })
  }
}
